<template>
  <div class="edu-testimonial-area sectionBg12 ptb-100">
    <div class="container">
      <div class="edu-testimonial-navigator">
        <carousel
          :autoplay="5000"
          :settings="settings"
          :wrap-around="true"
          :breakpoints="breakpoints"
        >
          <slide v-for="slide in carouselItems" :key="slide.id">
            <div class="edu-testimonial-navigator-item">
              <!-- İçerik -->
              <div class="edu-testimonial-nav-content text-center">
                <p class="sub-title">{{ slide.subTitle }}</p>
                <h2>
                  {{ slide.heading }}
                  <span class="shape02">Yorumlar</span>
                </h2>
                <h3>{{ slide.title }}</h3>
                <p>{{ slide.desc }}</p>
                <span class="client-name d-block mt-3">{{ slide.name }}</span>
                <span class="client-title">{{ slide.designation }}</span>
              </div>
            </div>
          </slide>

          <!-- Navigasyon -->
          <template #addons>
            <navigation>
              <template #next>
                <i class="bx bx-right-arrow-alt"></i>
              </template>
              <template #prev>
                <i class="bx bx-left-arrow-alt"></i>
              </template>
            </navigation>
          </template>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "OurTestimonial",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    carouselItems: [
      {
        id: 1,
        subTitle: "Katılımcı Yorumu",
        heading: "Öğrencilerimizden Değerli",
        title: "“Benim için gerçekten en iyi çözüm oldu”",
        desc: "Eğitim süreci boyunca hem teorik hem de pratik bilgiler edindim. Kariyerimde yeni bir bakış açısı kazandırdı.",
        name: "Ali Çoban",
        designation: "Yazılım Geliştrici",
      },
      {
        id: 2,
        subTitle: "Katılımcı Yorumu",
        heading: "Öğrencilerimizden Değerli",
        title: "“Eğitmenlerimizden en iyi tavsiyeleri aldım”",
        desc: "Ders içerikleri anlaşılır, destek ekibi her zaman yanımdaydı. Çok faydalı ve keyifli bir eğitim süreciydi.",
        name: "Ayşe Yılmaz",
        designation: "UI/UX Tasarımcı",
      },
    ],
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
  }),
});
</script>

<style scoped>
.edu-testimonial-navigator-item {
  display: flex;
  justify-content: center; /* Ortala */
  text-align: center; /* Yazıyı ortala */
}
.edu-testimonial-nav-content {
  max-width: 700px; /* içerik genişliği dengeli olsun */
}
</style>
